// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"676":"a4db9d0d6b817beecf59","908":"28685369ca203a87d0ac"}[chunkId] + ".js";
};